import "../../Styles/General & MultiUse/RegisterSuccess.css";
import { useContext, useEffect } from "react";
import ReactDOM from "react-dom";
import { ZGAContext } from "../../ZGAContext";
// import { useNavigate } from "react-router-dom";
import { RiCloseLargeLine } from "react-icons/ri";
import Success from "../../Assets/Success.png";
import Failure from "../../Assets/Failure.png";

const RegisterSuccess = () => {
  const { rSModal, hideRSModal } = useContext(ZGAContext);
  const { isVisible, message, isSuccess } = rSModal;
  // const navigate = useNavigate();
  const whatsappNumber = "2348133128088";
  const encodedMessage = encodeURIComponent("Hello, I just completed my registration.");
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

  useEffect(() => {
    const handlePopState = () => {
      if (isVisible) {
        hideRSModal();
      }
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [isVisible, hideRSModal]);

  if (!isVisible) return null;

  return ReactDOM.createPortal(
    <>
      <div className="backdrop"></div>
      <div className="registerSuccess">
        <RiCloseLargeLine className="cancel" onClick={hideRSModal} />
        <img className="rSImage" src={isSuccess ? Success : Failure} alt="" />
        <p>{message}</p>
        {isSuccess && (
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
              <button>Proceed to pay via WhatsApp</button>
            </a>
        )}
      </div>
    </>,
    document.getElementById("modal-root")
  );
};

export default RegisterSuccess;
